<template>

  <el-menu router :default-active="$route.fullPath">

    <!--<el-submenu index="1">-->
      <!--<template slot="title"><i class="el-icon-tickets"></i>首页</template>-->
<!--&lt;!&ndash;      <el-menu-item index="">友情链接</el-menu-item>&ndash;&gt;-->
    <!--</el-submenu>-->
    <!--<el-submenu index="2">-->
      <!--<template slot="title"><i class="el-icon-tickets"></i>加入我们</template>-->
      <el-menu-item index="/admin/product/list"><i class="el-icon-edit-outline"></i> 产品线</el-menu-item>
      <el-menu-item index="/admin/join/list"><i class="el-icon-edit-outline"></i> 招聘信息</el-menu-item>

    <!--</el-submenu>-->
<!--    <el-submenu>-->
      <el-menu-item index="/formui/simple_table?tableName=MiniKVTable" @click="pushTo('/formui/simple_table?tableName=MiniKVTable')"><i class="el-icon-chat-round"></i>小程序设置</el-menu-item>

      <el-menu-item index="/formui/simple_table?tableName=CustomerMiniTable" @click="pushTo('/formui/simple_table?tableName=CustomerMiniTable')"><i class="el-icon-chat-round"></i>小程序-客户</el-menu-item>
      <el-menu-item index="/formui/simple_table?tableName=ContactMiniTable"  @click="pushTo('/formui/simple_table?tableName=ContactMiniTable&b=2')"><i class="el-icon-chat-round"></i>小程序-联系</el-menu-item>
      <el-menu-item index="/formui/simple_table?tableName=ProductMiniTable" @click="pushTo('/formui/simple_table?tableName=ProductMiniTable&a=1')"><i class="el-icon-chat-round"></i>小程序-产品</el-menu-item>
      <el-menu-item index="/formui/simple_table?tableName=CardMiniTable" @click="pushTo('/formui/simple_table?tableName=CardMiniTable&a=3')"><i class="el-icon-chat-round"></i>小程序-名片</el-menu-item>
      <el-menu-item index="/admin/card/list_view"><i class="el-icon-chat-round"></i>小程序-名片-查看</el-menu-item>
<!--    </el-submenu>-->
  </el-menu>
</template>

<script>
export default {
  name: 'IndexLeft',
  mounted () {

  },
  data () {
    return {

    }
  },
  methods: {
    pushTo(item){
      location.href='#'+item
      // console.log(item)
      // this.$router.push({path: '/formui/simple_table',query:{tableName:'CustomerMiniTable'}})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/IndexLeft.vue